import { HeartIcon } from "../../assets/icons";
import "./footer.css";

const Footer = () => {
    return (
        <footer className="h6 font-medium mt-6">
            Made with <HeartIcon />
            by amartyars
        </footer>
    );
};

export { Footer };
